import history from "src/utils/history";
import { paths } from "src/routes/paths";
import { groupRowStyle } from "src/theme/palette";
import { createRemoteStore, REMOVED_ROW_CLASS } from "src/consuman-components/data-grid";
import { refreshToken } from "./token";

export function getDataSourceStore(url, options, filters) {
  options = options || {};

  return createRemoteStore({
    key: options.id || "id",
    method: options.method || "POST",
    url,
    params: filters,
    prepareHeaders: async () => {
      await refreshToken(true, false);

      return {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Consuman-TimeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
    },
    onError: ({ status }) => {
      if (status === 403 || status === 0) {
        history.push(paths.auth.login);
      }
    },
  });
}

export function getDateCalculateFilterExpression(filterValue, selectedFilterOperation, target) {
  if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
    const filterExpression = [
      [this.dataField, ">=", filterValue[0] ? filterValue[0].toISOString() : filterValue[0]],
      "and",
      [this.dataField, "<=", filterValue[1] ? filterValue[1].toISOString() : filterValue[1]],
    ];

    return filterExpression;
  }

  return [this.dataField, selectedFilterOperation || "contains", filterValue.toISOString()];
}

/**
 * `onSelectionChanged` handler for grids whose selection feeds a removal: an already removed record
 * cannot be removed again. Restored selections (state storing keeps the selected keys) and any path that
 * bypasses the row checkbox are covered here.
 */
export function deselectRemovedRows(e) {
  const removedIds = e.selectedRowsData.filter(row => !row.isActive).map(row => row.id);

  if (removedIds.length > 0) e.component.deselectRows(removedIds);
}

export function markRemovedRow(rowElement, isRemoved) {
  if (isRemoved) rowElement.classList.add(REMOVED_ROW_CLASS);
}

export function applyGroupRowStyle(rowElement, settings) {
  const { backgroundColor, color } = groupRowStyle(settings);

  rowElement.querySelectorAll("td").forEach(td => {
    td.style.backgroundColor = backgroundColor;
    td.style.color = color;
  });
}
